// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.careers-main-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.career-main-heading{
  color: #373334;
  font-size: 17px;
  font-weight: 700;
}
@media screen and (min-width: 768px) {
  .careers-main-container {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 20;
    padding: 10px 15px;
  }
}
.page-navigation-options-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 8px;
}

.page-navigation-options-container h3 {
  font-weight: 400;
  font-size: 30px;
}

@media screen and (min-width: 768px) {
  .page-navigation-options-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 8px;
  }
  .page-navigation-options-container h3 {
    font-weight: 400;
    font-size: 25px;
  }
}

.page-navigation-options {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 25px;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  margin: auto;
}
.page-options-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-inline-start: 15px;
  margin-block-start: 10px;
  padding-bottom: 3%;
  margin-inline-end: 30px;
  /* flex:auto; */
}

/* @media screen and (min-width: 768px) {
  .page-navigation-options {
    margin-right: 18px;
    margin-top: 18px;
    width: 300px;
  }
}
@media screen and (min-width: 1024px) {
  .page-navigation-options {
    margin-right: 18px;
    margin-top: 18px;
  }
} */

.careers-content-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px;
}

@media screen and (min-width: 768px) {
    .careers-content-container{
        align-items: flex-start;
        margin-top: 62px;
        padding: 10px 10px;
    }
}

.main-heading{
  font-weight: 600;
  font-size: 20px;
  color: #373334;
  margin-bottom: 4px;
  margin-top: 18px;
}
.main-heading-container{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  width: 90%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Careers/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,OAAO;IACP,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAmB;EAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;IACI;QACI,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":[".careers-main-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.career-main-heading{\r\n  color: #373334;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .careers-main-container {\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    gap: 20;\r\n    padding: 10px 15px;\r\n  }\r\n}\r\n.page-navigation-options-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 20px 8px;\r\n}\r\n\r\n.page-navigation-options-container h3 {\r\n  font-weight: 400;\r\n  font-size: 30px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .page-navigation-options-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    padding: 20px 8px;\r\n  }\r\n  .page-navigation-options-container h3 {\r\n    font-weight: 400;\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n.page-navigation-options {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #ffffff;\r\n  border-radius: 25px;\r\n  height: fit-content;\r\n  width: 100%;\r\n  margin: auto;\r\n}\r\n.page-options-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  margin-inline-start: 15px;\r\n  margin-block-start: 10px;\r\n  padding-bottom: 3%;\r\n  margin-inline-end: 30px;\r\n  /* flex:auto; */\r\n}\r\n\r\n/* @media screen and (min-width: 768px) {\r\n  .page-navigation-options {\r\n    margin-right: 18px;\r\n    margin-top: 18px;\r\n    width: 300px;\r\n  }\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .page-navigation-options {\r\n    margin-right: 18px;\r\n    margin-top: 18px;\r\n  }\r\n} */\r\n\r\n.careers-content-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  padding: 10px 5px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    .careers-content-container{\r\n        align-items: flex-start;\r\n        margin-top: 62px;\r\n        padding: 10px 10px;\r\n    }\r\n}\r\n\r\n.main-heading{\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  color: #373334;\r\n  margin-bottom: 4px;\r\n  margin-top: 18px;\r\n}\r\n.main-heading-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n  width: 90%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
